import type { Operator } from '../../../../shared/make-24';
import type { make24 as en } from '../en/make-24';

const OPERATOR_NAMES: Readonly<Record<Operator, string>> = {
  '+': '加',
  '-': '减',
  '*': '乘',
  '/': '除以',
};

export const make24: typeof en = {
  solvedChat: '算出来了！本题结束后才能聊天。',
  hand: (hand, hands) => `第 ${hand} 题，共 ${hands} 题`,
  gameOver: '游戏结束',
  gameEnded: '游戏已中止',
  waitingRoom: '等待室',
  messagePlaceholder: '说点什么…',
  resultsDetail: (hands) => `${hands} 题。`,
  aloneTitle: '叫上好友更好玩。',
  setup: (players, hands) =>
    `${players} 人，${hands} 题。每题所有人同时拿到相同的四个数字，越快算出来得分越高。`,
  guestSetup: (players, hands) => `${players} 人，${hands} 题。`,
  donePrompt: '不错！所有人算出来或时间到了，本题就结束。',
  handResults: (hand) => `第 ${hand} 题结果`,
  solved: '已解出',
  outOfTime: '时间到了',
  handOver: '这一题结束了',
  spectatorChatLocked: '一题进行中，观战者暂时不能发言',
  resultDetail: (expression, seconds) => `${expression} · 剩余 ${seconds} 秒`,
  noAnswer: '未解出',
  paused: '已暂停',
  handResultsLabel: (hand, hands) => `第 ${hand} 题结果，共 ${hands} 题`,
  nextHand: '下一题',
  finalScores: '最终得分',
  pointsForYou: (points) => `你获得 +${points} 分`,
  solvedWithTime: (seconds) => `解出时还剩 ${seconds} 秒`,
  oneWay: (solution) => `一种解法：${solution}`,
  nextHandSoon: '马上开始下一题',
  solvedPoints: (points) => `算出来了！+${points}`,
  waitingCount: (count) => `等待 ${count} 位玩家`,
  everyoneSolved: '所有人都算出来了',
  toSolve: '解题时间',
  makes: (value) => `结果是 ${value}`,
  undoPrompt: '撤销一步或重新开始',
  solvedCount: (count) => `${count} 人已解出`,
  solvedCountUndo: (count) => `${count} 人已解出 · 撤销一步`,
  useEachNumber: '每个数字用一次',
  away: '暂离',
  waiting: '等待中',
  solvedStatusPoints: (points) => `已解出 · +${points}`,
  solving: '正在计算',
  table: {
    operator: (operator) => OPERATOR_NAMES[operator],
    not24: '不是 24',
    cardFrom: (value, formula) => `${value}，来自 ${formula}`,
    pickNumber: '选一个数字。',
    pickSign: (value) => `为 ${value} 选一个运算符。`,
    pickSecond: (value, sign) => `${value} ${sign} ？选第二个数字。`,
    undo: '撤销',
    startOver: '重新开始',
    signs: '运算符',
    keys: '键盘：1 到 4 选牌，+ − × ÷ 选运算符，退格键撤销，Esc 重新开始。',
  },
  solo: {
    notYet: '暂无',
    runComplete: '本轮完成',
    solvedOf: (solved, hands) => `解出 ${solved} 题，共 ${hands} 题`,
    runResult: (solved, hands, time) =>
      `${time} 内解出 ${solved} 题，共 ${hands} 题。`,
    skipped: '已跳过',
    skippedPenalty: (skipped, time) => `${skipped} 题，+${time}`,
    fastestHand: '最快一题',
    none: '暂无',
    playAgain: '再玩一局',
    bestOnDevice: '本机最佳成绩',
    challengeDescription: (time) =>
      `好友拿到相同的十道题，挑战你的 ${time} 成绩。`,
    skippedPrompt: '这是一种解法。',
    nextHand: '下一题',
    nextHandPrompt: '马上开始下一题。',
    skip: '跳过，+30 秒',
    thisRun: '本轮',
    tenHands: '十题',
    runTime: '用时',
    skipPenalty: '计时加 30 秒',
    nice: '24！不错。',
    solvedIn: (time) => `用时 ${time} 解出`,
    firstRun: '这是你在本机的第一轮。',
    newBest: (time) => `刷新本机纪录！上次最佳用时是 ${time}。`,
    previousBest: (time) => `你的本机最佳用时是 ${time}。`,
    today: '今天',
    everyHand: '每题结果',
    skippedExpression: (expression) => `已跳过 · ${expression}`,
  },
};
